import type { FaireProductEntity } from "../../entity_types/product";

export const p_4wg3q7g74k: FaireProductEntity = {
  token: "p_4wg3q7g74k",
  type: "product",
  name: "Hand-Carved Wolf Serpentine Gemstone Figurine Animal",
  brandToken: "b_yv36hmng6n",
  brandName: "Gem Avenue Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/e0ec9c7de61c01bab3afa5f4b6377e59eb7cb61792418842c54c894b37a30767.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f5b7233cc293666dc9fc57e471202ef2a306327c11da446fd8340ed2795f7e27.jpeg",
    "https://cdn.faire.com/fastly/583c28c8c1a8b4a26dba2c1bb97d865403442a688421254ac4325f087527d8b9.jpeg",
    "https://cdn.faire.com/fastly/1d8e326e3f35c4bf83e46796b0320fb7a652db8d04bef76a9ccddb10455b69a3.jpeg",
    "https://cdn.faire.com/fastly/4cc1f7fbf9dc6f48cfa28ebb53e81af7d083c666858e7e57d249c55d71e56c3c.jpeg",
    "https://cdn.faire.com/fastly/b042896ea19042d342c18ec8259a68e6065c8cd56d97d10e6cea82791cbad5ed.jpeg",
  ],
  priceDollars: 149.65,
  description:
    "Introduce an exotic touch to your inventory with our Hand-Carved Wolf Serpentine Gemstone Figurine. Each piece is carved from high-quality serpentine gemstone by skilled artisans in Zimbabwe. With a variety of animal figurines, these wholesale carvings will make a unique addition to any retailer's collection, allowing for a good profit.\n",
  tags: [],
  msrpDollars: 299.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:09.285Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
